module.exports = __webpack_public_path__ + "static/img/20220507_01.8e3e925.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20220507_01.png
// module id = bE71
// module chunks = 0